import { PPA_ADD } from './index';
import { Action } from '../action';
import { PaymentPPAInfo } from '@shared/core';

export class PpaAddInitAction implements Action {
	readonly type = PPA_ADD.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PpaAddDestroyAction implements Action {
	readonly type = PPA_ADD.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PpaAddSubmitAction implements Action {
	readonly type = PPA_ADD.SUBMIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PpaAddSubmitSuccessAction implements Action {
	readonly type = PPA_ADD.SUBMIT_SUCCESS;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class PpaAddSubmitFailureAction implements Action {
	readonly type = PPA_ADD.SUBMIT_FAILURE;
	constructor(
		public payload: any,
		public correlationId?: number
	) {}
}

export class PpaAddFormUpdateAction implements Action {
	readonly type = PPA_ADD.FORM_UPDATE;
	constructor(
		public payload: PaymentPPAInfo,
		public correlationId?: number
	) {}
}
